import { MobileDatePicker } from '@mui/lab'
import { TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'

interface DatePickerCProps {
  name: string
  inputFormat?: string
  style?: any
  label?: string
  minDate?: any
  maxDate?: any
  onChange?: (date: any, keyboardInputValue?: string | undefined) => void
  disabled?: boolean
}

export const DatePickerC = (props: DatePickerCProps) => {
  const {
    name,
    label,
    inputFormat,
    minDate,
    maxDate,
    onChange,
    disabled = false
  } = props
  const { formState } = useFormContext()

  return (
    <FieldWrapper error={_get(formState.errors, name)}>
      <Controller
        name={name}
        render={({ field }) => (
          <MobileDatePicker
            {...field}
            onChange={(date: any, keyboardInputValue?: string) => {
              onChange?.(date, keyboardInputValue)
              field.onChange(date, keyboardInputValue)
            }}
            label={label}
            inputFormat={inputFormat}
            cancelText="Cancelar"
            okText="Ok"
            disabled={!!disabled}
            minDate={minDate}
            maxDate={maxDate}
            renderInput={(params: any) => (
              <TextField
                size="small"
                fullWidth
                {...params}
                error={_get(formState.errors, name)}
              />
            )}
          />
        )}
      />
    </FieldWrapper>
  )
}
